module.exports = __webpack_public_path__ + "static/media/tabbot-worried.5d821d86.png";